export enum ActionKeyEnum {
	EditInternshipDocument,
	ValidateInternshipDocument,
	DownloadInternshipDocument,
}

export type DiplomaStudentsViewProps = {
	initialInternshipName?: string;
};
